// Datei: load-more.js

const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;

  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPageScroll);

  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML) {
      // 1) Neue Produkte ins DOM anhängen
      $('.load-more-grid').append(
        $(responseHTML).find('.load-more-grid').html()
      );

      // 2) Theme-Funktion (Farbswatches etc.)
      colorSwatches();

      // 3) Custom Event "productsAppended" dispatchen,
      //    damit andere Skripte (z.B. dein Filter) reagieren können
      const evt = new Event('productsAppended');
      document.dispatchEvent(evt);
    },
    complete: function() {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value = nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
          scollData.querySelector('input[data-current-page]').value = currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');

        // Wenn wir die letzte Seite erreicht haben, entfernen wir den Button
        if (currentPage == totalPages) {
  button.remove();
  // NEU: fires allPagesLoaded
  document.dispatchEvent(new Event('allPagesLoaded'));
}
      }
    }
  });
};

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
        }
      });
    });
    sectionObserver.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
